import React from "react"

import { Link } from "gatsby"

import '../styles/components/pageMenu.scss';

import useLanguage from "../hooks/useLanguage";

import PropTypes from "prop-types";
import { createInternalLink } from "../utils/createInternalLink/createInternalLink";



const PageMenu = ({ listLinks = [], title = '', toChoose = '', page='', closeFn={} }) => {
    const [currentLanguage] = useLanguage();

    return (
        <div className="PageMenu">
            <div className="PageMenu-Inner">
                <div className="container">
                    <div className="PageMenu-Cell">
                        <div className="PageMenu-CellTitle">{title}</div>
                        <div className="listPageMenuLinks">
                            {listLinks.map((item) => (
                                <Link
                                    key={`PageMenu_${item.query}`}
                                    to={item.link ? createInternalLink(currentLanguage, item.link) : createInternalLink(currentLanguage, `/${page}/${item.query}`)}
                                    className={`pageMenuLink ${ toChoose === item.query || toChoose.includes(item.query) ? 'active' : '' }`}
                                    activeClassName="active"
                                    onClick={closeFn}
                                >
                                    {item.title}
                                </Link>)
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export const PageMenuPropTypes = {
    toChoose: PropTypes.any,
    listLinks: PropTypes.array,
    title: PropTypes.string,
    page: PropTypes.string
};

PageMenu.propTypes = PageMenuPropTypes;

export default PageMenu;
